export const generateTimes = () => {
  const times = [];

  for (let i = 0; i < 24 * 2; i++) {
    // 24 hours * 2 for 30 min intervals
    const hour = Math.floor(i / 2);
    const minute = i % 2 === 0 ? '00' : '30';
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour; // Convert 0 to 12

    // const label = `${String(hour).padStart(2, '0')}.${minute} (${String(
    //   hour12
    // ).padStart(2, '0')}.${minute} ${ampm})`;

    const label = `${String(hour12).padStart(2, '0')}:${minute} ${ampm}`;

    const value = `${String(hour).padStart(2, '0')}:${minute}`;

    times.push({
      id: i,
      value: value,
      label: label,
    });
  }

  return times;
};

export function range(start, end, step) {
  const len = Math.floor((end - start) / step) + 1;
  return Array(len)
    .fill()
    .map((_, idx) => start + idx * step);
}

export const getYear = (date) => date.getFullYear();

export const getMonth = (date) => date.getMonth();

export const years = range(1990, getYear(new Date()) + 1, 1);

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function convertTo12HourFormatWithLabel(timeString) {
  // Extract hours and minutes from the time string
  const [hours, minutes] = timeString.split(':').map(Number);

  // Determine AM or PM
  const period = hours >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  let hours12 = hours % 12;
  hours12 = hours12 === 0 ? 12 : hours12; // Handle 12 AM and 12 PM

  // Format the time in 12-hour format
  const time12HourFormat = `${hours12}:${minutes
    .toString()
    .padStart(2, '0')} ${period}`;

  // Construct the final string with the original railway time and 12-hour format time
  // const finalString = `${timeString} ( ${time12HourFormat} )`;
  const finalString = `${timeString} ( ${time12HourFormat} )`;

  return finalString;
}
